import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import { Button, Card, Col, Form, Typography, Input, Radio, Row, Upload } from 'antd'
import { useDeepEffect } from '../../../utils/hooks'
const UserForm = (props) => {
  const { formDataUser, setFormDataUser, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const { Title, Paragraph, Text } = Typography;
  useDeepEffect(() => {
    if (!isEmpty(formDataUser)) {
      setFieldsValue({
        name: formDataUser.name,
        email: formDataUser.email,
        tel: formDataUser.tel,
      })
    }
  }, [formDataUser])

  return (
    <Card>
      <Row type="flex" justify="end" align="bottom">
        <Col>
          <Text type="danger">*กรุณากรอกข้อมูลต่อไปนี้ตามความเป็นจริง</Text>
        </Col>
      </Row>
      <Form form={form} layout="vertical">
        <Form.Item label="ชื่อ-นามสกุล">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataUser({ ...formDataUser, name: event.target.value })
          } />)}
        </Form.Item>
        <Form.Item label="อีเมล">
          {getFieldDecorator(`email`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataUser({ ...formDataUser, email: event.target.value })
          } />)}
        </Form.Item>
        <Form.Item label="ที่อยู่">
          {getFieldDecorator(`tel`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input onChange={(event) =>
            setFormDataUser({ ...formDataUser, tel: event.target.value })
          } />)}
        </Form.Item>
      </Form>
    </Card>
  )
}
const WrappedUserForm = Form.create({ name: 'UserForm' })(
  UserForm
)
export default WrappedUserForm



// WEBPACK FOOTER //
// ./src/pages/CreateBrand/UserForm/index.js